import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class MemberLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
